import { render, staticRenderFns } from "./uploadTemplate.vue?vue&type=template&id=62f3aa4d&scoped=true&"
import script from "./uploadTemplate.vue?vue&type=script&lang=js&"
export * from "./uploadTemplate.vue?vue&type=script&lang=js&"
import style0 from "./uploadTemplate.vue?vue&type=style&index=0&id=62f3aa4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f3aa4d",
  null
  
)

export default component.exports